<template>
    <div class="flats-crm-filter-mobile" :class="{'open' : filterVisible}">
        <div class="top-header">
            <a href="#" class="link-back" @click.prevent="closeFilterMobile">
                <svg-icon icon-class="left-arrow" className="svg-icon icon-arrow-left"/>
                <span>Назад</span>
            </a>
            <h3>ФИЛЬТР</h3>
            <a href="#" class="link-reset" @click.prevent="resetFilterCrm"
                v-scroll-to="{
                    el: '.flats-crm-items-container',
                    offset: -110
                }">
                Сбросить
            </a>
        </div>
        <div class="flats-filtter-container">
            <flatsFilter></flatsFilter>
        </div>
    </div>   
</template>

<script>
    import {mapGetters} from 'vuex'
	import flatsFilter from '@/components/flats-crm/flats-crm-filter.vue'
    export default {
        name: 'sale-CRM-flats-filter-mobile',
        components: {
            flatsFilter,
        },
        data () {
            return {
                filterData: null,
                count: 0,
            }
        },
        computed: mapGetters({
            filterVisible: 'loadVisibleFilterMobile',
            banerTopCoockieVisible: 'loadCockieBanerTopVisible',
            saleFilterParams: 'loadsaleFilterParamsContent',
            salesCardPage: 'loadSalesCardPage',
            saleItem: 'loadSaleCardItem',
            saleFilterParams: 'loadSalesFilterCardParams',
            paginPageNumber: 'loadPaginPageNumber',
            resetModeTrigger: 'loadResetTriggerMove',
        }),
        methods: {
            closeFilterMobile() {
                window.body.removeClass('overflowTrue');
                if (this.banerTopCoockieVisible == true) {
                    document.getElementById('banerTopHorizont').classList.remove('notvisibleSalesLand');
                }
                document.getElementById('header').classList.remove('notvisibleSalesLand');
                document.getElementById('footer').classList.remove('notvisibleSalesLand');
				this.$store.commit('SetVisibleFilterMobile', false);
            },
            resetFilterCrm() {
                this.count = this.count + 1;
                this.filterData = {
                    complexCodes: [this.saleFilterParams.crm_code],
                    roomQuantities: [],
                    areaFrom: this.saleFilterParams.filter_set_size.min,
                    areaTo: this.saleFilterParams.filter_set_size.max,
                    floorRangeStart: this.saleFilterParams.filter_set_floor.min,
                    floorRangeEnd: this.saleFilterParams.filter_set_floor.max,
                    meterPriceFrom: this.saleFilterParams.filter_set_money.min,
                    meterPriceTo: this.saleFilterParams.filter_set_money.max,
                    linesOnPage: 12,
                    pageNumber: 1,
                };
                this.$store.commit('UpdatePaginPageNumber', 1);
                this.$store.commit('setFlatsFilterData', this.filterData);
                this.$store.dispatch('getFlatsByFilter', this.filterData);
                this.closeFilterMobile();
                this.$store.commit('TriggerResetFilterMove', this.count);
            },
        },
        beforeCreate() {
        },
        created () {
        },
        mounted () {
        }
    }
</script>

<style lang="scss">
    // @import '@/styles/components/flats-crm/flats-crm-filter.scss';
    @import '@/styles/components/flats-crm/respond/flats-crm-filter-mobile.scss';
</style>